
import canUseDOM from '../utilities/canUseDOM';

export const updateSavedItemsCount = (quantity: number) => {
  if (canUseDOM()) {
    const savedForLaterCounter = document.querySelector<HTMLSpanElement>(
      '.header-icon__badge--saved-for-later'
    );

    if (savedForLaterCounter) {
      savedForLaterCounter.innerText = quantity.toString();
    }
  }
}